import React from 'react'
import ListaGastosPorDia from '../../Componentes/ListaGastosPorDia';
import './estilos.css';

function ListaGastosPorDiaPage() {
    return (
        <div className='cont-lista-gastos-page'>
            <ListaGastosPorDia />
        </div>
    )
}

export default ListaGastosPorDiaPage